import React from 'react';
import styled from 'styled-components/macro';

import PageElements from '@mirinae/lessons/components/lesson/PageElements';
// import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Text from '@mirinae/lessons/components/lesson/elements/Text';

import { PageTop } from './DefaultPage';

const GoalText = styled.div`
    width: 100%;
    & > div {
        padding: 12px 5px;
    }
    span {
        // animation: goalFadeIn 2s linear forwards;   fade-in goal text, disabled per current design
    }
    @keyframes goalFadeIn {
        0% { opacity: 0 }
        50% { opacity: 0 } 
        100% { opacity: 1 }
    }
`;

const AnimateGoalText = ({ element }) => <GoalText><Text element={element} /></GoalText>;

// the renderer for lesson goal pages, starts with empty goal text 500ms, fades-up text 350ms,
// shows 2000ms, auto-step to next page ??? not sure about this!!
const LessonGoal = ({ page }) => {
    // const player = useContext(PlayerContext);

    // auto-advance on this page, disabled per current design
    // useEffect(() => {
    //     const timer = setTimeout(player.next, 4000); // auto step to next page 2s efter goalText appears
    //     return () => clearTimeout(timer);
    // });

    // map over page elements for current page-build step
    return (
        <>
            <PageTop page={page} />
            <PageElements page={page} except={['continueButton']} mapComponent={e => e.componentName === 'goalText' && AnimateGoalText} />
        </>
    );
};

export default LessonGoal;
